<script>
import {ref} from "vue";
import Swals from "@/assets/js/Swals";
import router from "@/router";
import FreeWorld from "@/assets/js/FreeWorld";
import useClipboard from 'vue-clipboard3'
import {useStore} from "vuex";

export default {
  name: "LoginPage",

  setup() {

    let store = useStore()
    let loading = ref(false)

    let privacy = ref(false)
    let data = ref({
      phone: '',
    })

    function login_phone() {

      if (data.value.phone.length != 11) {
        Swals.Fault('لطفا شماره همراه خود را به صورت صحیح وارد کنید')
        return false
      }
      if (data.value.phone.charAt(0) != 0 || data.value.phone.charAt(1) != 9) {
        Swals.Fault('لطفا شماره همراه خود را با پیش شماره 09 وارد کنید')
        return false
      }
      if (!privacy.value) {
        Swals.Fault('پذیرفتن شرایط و قوانین الزامی است')
        return false
      }

      loading.value = true
      FreeWorld.Heisenberg(data.value, 'phone').then((result) => {

        loading.value = false
        if (result.data.status == 'ok') {
          router.push({name: 'OtpPage', params: {phone: data.value.phone}})
        }

      }).catch((result) => {

        loading.value = false
        Swals.Catch(result, login_phone)

      })

    }

    let showSupport = ref(true)

    function hideSupportCall() {
      showSupport.value = false;
    }

    function showSupportCall() {
      showSupport.value = true;
    }

    const {toClipboard} = useClipboard()
    async function call_support() {
      let phone_support = store.state.info.phone
      await Swals.Dialog(phone_support, null, 'کپی کردن', 'انصراف').then(async (res) => {
        if (res.isConfirmed) {
          try {
            await toClipboard(phone_support)
            Swals.Done('شماره پشتیبانی با موفقیت کپی شد');
          } catch (e) {
            Swals.Fault('متاسفانه شماره پشتیبانی کپی نشد!');
          }
        }
      });
    }


    return {

      loading,
      privacy,
      login_phone,
      data,
      call_support,
      showSupport,
      hideSupportCall,
      showSupportCall,

    }
  }
}
</script>


<template>


  <div id="main" :class="loading ? 'pe-none':'' " class="">

    <img class="patch position-absolute max_width top-0" src="../assets/img/Path.png" alt="">

    <div class="d-flex justify-content-center mt-5">
      <img class="position-relative img_logo" src="../assets/img/logo.png" alt="">
    </div>

    <div class="p-body position-relative w-100 mt-3">
      <div class="rounded-4 shadow-custom py-5 w-100 p-body filter_blur">
        <p class="font-4 text-center text-white font-bold mb-5">جهت ورود لطفا شماره همراه خود را وارد کنید</p>

        <div class="p-2 mb-5 rounded-pill position-relative bg-white">
          <input v-model="data.phone" id="input_phone" class="w-100 border-0 p-2 text-center" type="tel" maxlength="11"
                 @focusin="hideSupportCall" @focusout="showSupportCall"  placeholder="شماره همراه">
          <img class="position-absolute icon_phone" src="../assets/img/icon_login.svg" alt="">
        </div>

        <div class="d-flex align-items-center">
          <input v-model="privacy" id="privcy" type="checkbox">
          <label class="font-5 text-white font-bold mr-3" for="privcy">تمام <a class="font-color_light"
                                                                               href="https://market-app.ir/rules?action=rules"
                                                                               target="_blank">شرایط و قوانین</a> برنامه
            و <a class="font-color_light" href="https://market-app.ir/rules?action=privacy" target="_blank">حریم
              خصوصی</a> را میپذیرم</label>
        </div>

        <div style="margin-top: 10vh" class="w-100 d-flex justify-content-center">
          <v-btn @click="login_phone" :loading="loading" class="bg-color-light h-100 shadow-custom rounded-3 py-3 w-70">
            ارسال کد
          </v-btn>
        </div>
      </div>
    </div>

    <div v-show="showSupport" id="support_call" class="position-fixed max_width w-100 bottom-0">
      <div @click="call_support"
          style="width: 10rem" class="bg-color p-1 shadow-custom rounded-pill d-flex align-items-center mr-3 mb-3">
        <img class="icon-size-5" src="../assets/img/icon_phon_liner.svg" alt="">
        <p class="font-4 text-white mr-3">پشتیبانی</p>
      </div>
    </div>

  </div>


</template>


<style scoped>

.patch {
  width: 101%;
  height: 700px;
}

.icon_phone{
  right: 0;
  width: 3.5rem;
  height: 3.5rem;
  top: 54%;
  transform: translate(0, -52%);
}

.filter_blur {
  backdrop-filter: saturate(1) blur(15px);
  -webkit-backdrop-filter: blur(10px);
  background-color: #f0f8ff1c;
}

.img_logo {
  //width: 80%;
  height: 250px;
}


</style>